import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertController, IonicModule, IonModal, ToastController } from '@ionic/angular';
import { BerService } from '../ber.service';

/**
 *  Az alkalmazott ÁLLANDÓ TÉTELEI és NYUGDÍJPÉNZTÁRI TAGSÁGA (backend/ber-torzs.js).
 *  Az állandó tétel az érvényességi időszak minden hónapjában bekerül a számfejtésbe (fix összeg
 *  vagy az alapbér %-a); a tagság a munkavállalói tagdíjat (levonás) és a munkáltatói
 *  hozzájárulást (bérként adózó jövedelem, a pénztárnak utalva) adja.
 */
@Component({
  selector: 'app-ber-tetelek-panel',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './tetelek-panel.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../ber-shared.scss'],
  // A ber-shared oldal-szintű alsó térköze egy beágyazott panelnél fölösleges rés lenne.
  styles: [':host { padding-bottom: 0; }'],
})
export class BerTetelekPanelComponent implements OnChanges {
  @Input() alkalmazott: any;
  @ViewChild('allModal') allModal: IonModal;
  @ViewChild('nypModal') nypModal: IonModal;

  allandok: any[] = [];
  tagsagok: any[] = [];
  jogcimek: any[] = [];
  penztarak: any[] = [];
  allSzerk: any = null;
  nypSzerk: any = null;

  constructor(private ber: BerService, private toast: ToastController, private alert: AlertController) {}

  get aktiv() { return this.ber.aktiv; }
  get rogzithetoJogcimek() { return this.jogcimek.filter((j) => !j.rendszer && j.aktiv); }

  async ngOnChanges() {
    if (!this.alkalmazott?.id) return;
    try {
      [this.allandok, this.tagsagok] = await Promise.all([
        this.ber.torzsApi.get<any[]>('/allando/' + this.alkalmazott.id), this.ber.torzsApi.get<any[]>('/tagsagok/' + this.alkalmazott.id)]);
    } catch { this.allandok = []; this.tagsagok = []; }
  }
  private async torzsek() {
    if (!this.jogcimek.length) this.jogcimek = await this.ber.torzsApi.get<any[]>('/jogcimek/' + this.aktiv.intezmeny).catch(() => []);
    if (!this.penztarak.length) this.penztarak = (await this.ber.torzsApi.get<any[]>('/nyugdijpenztarak/' + this.aktiv.intezmeny).catch(() => [])).filter((p) => p.aktiv);
  }
  private ma() { return new Date().toISOString().slice(0, 10); }

  async ujAllando() {
    await this.torzsek();
    this.allSzerk = { ugyfel_id: this.aktiv.ugyfelId, alkalmazott_id: this.alkalmazott.id, jogcim_id: this.rogzithetoJogcimek[0]?.id || null,
      mod: 'osszeg', osszeg: null, szazalek: null, tol: this.ma().slice(0, 8) + '01', ig: null, megjegyzes: '' };
    this.allModal.present();
  }
  async szerkAllando(a: any) {
    await this.torzsek();
    this.allSzerk = { ...a, mod: a.szazalek != null ? 'szazalek' : 'osszeg' };
    this.allModal.present();
  }
  async mentAllando() {
    const b = { ...this.allSzerk };
    if (b.mod === 'szazalek') b.osszeg = null; else b.szazalek = null;
    try { await this.ber.torzsApi.post('/allando', b); await this.allModal.dismiss(); await this.ngOnChanges(); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  async ujTagsag() {
    await this.torzsek();
    if (!this.penztarak.length) return this.hiba('Előbb vegyél fel nyugdíjpénztárat (Törzsadatok → Nyugdíjpénztár törzs).');
    this.nypSzerk = { ugyfel_id: this.aktiv.ugyfelId, alkalmazott_id: this.alkalmazott.id, penztar_id: this.penztarak[0].id,
      tagdij_szazalek: null, tagdij_osszeg: null, munkaltatoi_szazalek: null, munkaltatoi_osszeg: null, tol: this.ma().slice(0, 8) + '01', ig: null };
    this.nypModal.present();
  }
  async szerkTagsag(t: any) { await this.torzsek(); this.nypSzerk = { ...t }; this.nypModal.present(); }
  async mentTagsag() {
    try { await this.ber.torzsApi.post('/tagsag', this.nypSzerk); await this.nypModal.dismiss(); await this.ngOnChanges(); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  async torol(ut: string, nev: string) {
    const a = await this.alert.create({ header: 'Törlés', message: `Biztosan törli: ${nev}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive' }] });
    await a.present();
    if ((await a.onDidDismiss()).role !== 'destructive') return;
    try { await this.ber.torzsApi.del(ut); await this.ngOnChanges(); this.ok('Törölve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }

  osszegSzoveg(osszeg: any, szazalek: any, alap: string): string {
    if (szazalek != null && szazalek !== '') return `${Number(szazalek)}% (${alap})`;
    if (osszeg != null && osszeg !== '') return Number(osszeg).toLocaleString('hu-HU') + ' Ft';
    return '—';
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1800, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3200, color: 'danger' })).present(); }
}
